import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface EnrollmentAuditEntry {
  id: number;
  enrollmentId?: number | null;
  corporateEnrollmentId?: number | null;
  corporateParticipantId?: number | null;
  action: number;
  actionName: string;
  category: number;
  categoryName: string;
  performedByUserId: string;
  performedByEmail: string;
  performedByFullName?: string | null;
  performedAt: string;
  summary: string;
  reason?: string | null;
  beforeJson?: string | null;
  afterJson?: string | null;
  relatedAuditLogId?: number | null;
  relatedPaymentPlanVersionId?: number | null;
  relatedCorporatePaymentPlanVersionId?: number | null;
  relatedPortfolioMovementId?: number | null;
  relatedCorporatePortfolioMovementId?: number | null;
  relatedIncomeReceiptId?: number | null;
}

export interface EnrollmentAuditHistoryPage {
  items: EnrollmentAuditEntry[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export enum EnrollmentAuditCategory {
  Status = 1,
  PaymentPlan = 2,
  Portfolio = 3,
  Income = 4,
  Settings = 5,
  Observation = 6,
  Participants = 7,
  Access = 99,
}

export interface AuditHistoryQuery {
  pageNumber?: number;
  pageSize?: number;
  category?: EnrollmentAuditCategory | null;
  fromDate?: string | null;
  toDate?: string | null;
}

@Injectable({ providedIn: 'root' })
export class EnrollmentAuditService {
  private readonly baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getIndividualHistory(enrollmentId: number, query: AuditHistoryQuery = {}): Observable<EnrollmentAuditHistoryPage> {
    return this.http.get<EnrollmentAuditHistoryPage>(
      `${this.baseUrl}/Enrollment/${enrollmentId}/audit-history`,
      { params: this.toParams(query) }
    );
  }

  getCorporateHistory(agreementId: number, query: AuditHistoryQuery = {}): Observable<EnrollmentAuditHistoryPage> {
    return this.http.get<EnrollmentAuditHistoryPage>(
      `${this.baseUrl}/CorporateEnrollment/${agreementId}/audit-history`,
      { params: this.toParams(query) }
    );
  }

  private toParams(query: AuditHistoryQuery): HttpParams {
    let params = new HttpParams();
    if (query.pageNumber) params = params.set('pageNumber', query.pageNumber);
    if (query.pageSize) params = params.set('pageSize', query.pageSize);
    if (query.category != null) params = params.set('category', query.category);
    if (query.fromDate) params = params.set('fromDate', query.fromDate);
    if (query.toDate) params = params.set('toDate', query.toDate);
    return params;
  }
}
